export default [
  {
    path: '/main/passData',
    name: 'passData',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'dataSearch' */ '../pages/dataSearch/passData/passData.vue')
  },
  {
    path: '/main/passDataProject',
    name: 'passDataProject',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'dataSearch' */ '../pages/dataSearch/passDataProject/passDataProject.vue')
  },
  {
    path: '/main/operationLog',
    name: 'operationLog',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'dataSearch' */ '../pages/dataSearch/operationLog/operationLog.vue')
  },
  {
    path: '/main/messageRecordingSearch',
    name: 'messageRecordingSearch',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'dataSearch' */ '../pages/dataSearch/messageRecordingSearch/messageRecordingSearch.vue')
  },
  {
    path: '/main/messageRecordingSearchProject',
    name: 'messageRecordingSearchProject',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'dataSearch' */ '../pages/dataSearch/messageRecordingSearch/messageRecordingSearchProject.vue')
  },
  {
    path: '/main/thirdPartyCallRecord',
    name: 'thirdPartyCallRecord',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'dataSearch' */ '../pages/dataSearch/thirdPartyCallRecord/thirdPartyCallRecord.vue')
  },
  {
    path: '/main/visitorTrackProject',
    name: 'visitorTrackProject',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'dataSearch' */ '../pages/dataSearch/visitorTrackProject/visitorTrackProject.vue')
  },
  {
    path: '/main/alarmQuery',
    name: 'alarmQuery',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'dataSearch' */ '../pages/dataSearch/alarmQuery/index.vue')
  },
  {
    path: '/main/cloudSummaryOfDataProject',
    name: 'cloudSummaryOfDataProject',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'dataSearch' */ '../pages/dataSearch/cloudSummaryOfData/cloudSummaryOfDataProject.vue')
  },
  {
    path: '/main/cloudSummaryOfData',
    name: 'cloudSummaryOfData',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'dataSearch' */ '../pages/dataSearch/cloudSummaryOfData/cloudSummaryOfData.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/dataSearch.js